import Modal from "react-modal";
import { useState, useEffect } from "react";

interface ValidationWarningDialogProps {
  show: boolean;
  errorMessage: string;
  onCancel: () => void;
  onOverride: () => void;
}

const getModalStyles = (x: number, y: number) => ({
  content: {
    top: "auto",
    left: "50%",
    right: "auto",
    bottom: "10%",
    marginRight: "-50%",
    transform: `translate(calc(-50% + ${x}px), ${y}px)`,
    maxWidth: "500px",
    width: "90%",
    padding: "0",
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
});

export default function ValidationWarningDialog({
  show,
  errorMessage,
  onCancel,
  onOverride,
}: ValidationWarningDialogProps) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  // Reset position when dialog opens
  useEffect(() => {
    if (show) {
      setPosition({ x: 0, y: 0 });
    }
  }, [show]);

  // Handle drag events
  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e: MouseEvent) => {
      const deltaX = e.clientX - dragStart.x;
      const deltaY = e.clientY - dragStart.y;
      setPosition({ x: deltaX, y: deltaY });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, dragStart]);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  return (
    <Modal isOpen={show} onRequestClose={onCancel} shouldCloseOnOverlayClick={false} style={getModalStyles(position.x, position.y)}>
      <div className="modal-header p-3" style={{ cursor: "move" }} onMouseDown={handleMouseDown}>
        <h5 className="modal-title">Validation Warning</h5>
      </div>
      <div className="modal-body p-3">
        <div className="mb-3">
          <p className="mb-2" style={{ whiteSpace: "pre-wrap" }}>{errorMessage}</p>
        </div>
        <p className="mb-0">Would you like to cancel the submission to correct the text or override this warning?</p>
      </div>
      <div className="modal-footer p-3 gap-2">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-warning" onClick={onOverride}>
          Override Warning
        </button>
      </div>
    </Modal>
  );
}
